query UserTemplates( $orderBy: [DepartmentOccupationTemplatesOrderBy!]) {
  departmentOccupationTemplates(orderBy: $orderBy) {
    nodes {
      id
      name
      description
       _rowTimestamp
      _isUpdatable
      _isDeletable
      }
      }
      }